import { Platform } from "core/hooks/useMobilePlatform";
import { externalLink } from "core/links";
import { trackEvents } from "core/monitoring/Events";
import { EventNames } from "core/monitoring/types/enums";

export const handleWisdomStoreClick = (store: Platform, source: string) => {
  if (store === Platform.ios) {
    trackEvents(EventNames.WISDOM_APPSTORE_CLICK, { source });
    process.env.REACT_APP_WISDOM_APPSTORE_URI && externalLink(process.env.REACT_APP_WISDOM_APPSTORE_URI, false);
  }
  if (store === Platform.android) {
    trackEvents(EventNames.WISDOM_PLAYSTORE_CLICK, { source });
    process.env.REACT_APP_WISDOM_PLAYSTORE_URI && externalLink(process.env.REACT_APP_WISDOM_PLAYSTORE_URI, false);
  }
};
